import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminRoute from './AdminRoute';
import Home from '../Views/Home';
import Calendrier from '../Views/User/Calendrier';
import Profil from '../Views/User/Profil'
import Admin from '../Views/Administration/Admin';
import UserManagement from '../Views/Administration/UserManagement';
import Projets from '../Views/Projets/Projets';
import Clients from '../Views/Client/Clients';
import Client from '../Views/Client/Client';
import Tickets from '../Views/Tickets/Tickets';
import TicketsFermes from '../Views/Tickets/TicketsFermes';
import Ticket from '../Views/Tickets/Ticket';
import TicketsApprobation from '../Views/Tickets/TicketsApprobation';
import UserAdministration from '../Views/Administration/UserAdministration';
import GroupAdministration from '../Views/Administration/GroupAdministration';
import ChampsAdministration from '../Views/Administration/ChampsAdministration';
import ChampDetail from '../Views/Administration/ChampDetail';
import Projet from '../Views/Projets/Projet';
import Statistiques from '../Views/User/Statistiques';
import ResetPassword from '../Views/Login/ResetPassword';


// Component to restrict access for specific roles (deny-list)
const RestrictedRoute = ({ children, restrictedRoles = [] }) => {
  const { hasRole } = useAuth();
  const isRestricted = restrictedRoles.some(role => hasRole(role));
  if (isRestricted) return <Navigate to="/home" replace />;
  return children;
};

// Component to require a specific permission (allow-list)
const PermissionRoute = ({ children, requiredPermission }) => {
  const { hasPermission } = useAuth();
  if (!hasPermission(requiredPermission)) return <Navigate to="/home" replace />;
  return children;
};

// Component for admin-only pages that can also be unlocked by specific permissions
const AdminOrPermissionRoute = ({ children, anyPermission = [] }) => {
  const { isAdmin, hasAnyPermission } = useAuth();
  if (!isAdmin() && !hasAnyPermission(anyPermission)) return <Navigate to="/home" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>

      {/* Route publique pour la réinitialisation du mot de passe - accessible sans authentification */}
      <Route path="/reset-password" element={<ResetPassword />} />

      <Route path="/home" element={<Home titre="Tableau de bord" />} />
      <Route path="/statistiques" element={<PermissionRoute requiredPermission={'SEE_STATS'}><Statistiques titre="Statistiques" /></PermissionRoute>} />
      <Route path="/calendrier" element={<Calendrier titre="Calendrier entreprise" />} />

      <Route path="/client" element={<Client />} />
      <Route path="/client/:clientId" element={<Client />} />
      <Route path="/clients" element={<Clients titre="Clients" />} />

      <Route path="/projets" element={<RestrictedRoute restrictedRoles={['SUPPORT']}><Projets titre="Projets" /></RestrictedRoute>} />
      <Route path="/projet/:projetId" element={<RestrictedRoute restrictedRoles={['SUPPORT']}><Projet titre="Projet" /></RestrictedRoute>} />


      <Route path="/tickets" element={<Tickets titre="Tickets" />} />
      <Route path="/ticket/:ticketId" element={<Ticket titre="Ticket" />} />
      <Route path="/tickets-fermes" element={<TicketsFermes titre="Tickets fermés" />} />
      <Route path="/ticket-attente-approbation" element={<PermissionRoute requiredPermission="APPROVE_TICKET"><TicketsApprobation titre="Tickets à approuver" /></PermissionRoute>} />

      <Route path="/profil" element={<Profil titre="Paramètres du compte - Profil" />} />

      <Route path="/administration" element={<AdminRoute><Admin titre="Administration" /></AdminRoute>} />
      <Route path="/administration/utilisateur/:userId" element={<AdminOrPermissionRoute anyPermission={['SEE_USER','CREATE_USER','EDIT_USER','DELETE_USER']}><UserManagement /></AdminOrPermissionRoute>} />
      <Route path="/administration-utilisateur" element={<AdminOrPermissionRoute anyPermission={['SEE_USER','CREATE_USER','EDIT_USER','DELETE_USER']}><UserAdministration titre="Utilisateurs" /></AdminOrPermissionRoute>} />
      <Route path="/administration-groupe" element={<AdminOrPermissionRoute anyPermission={['SEE_GROUP','CREATE_GROUP','EDIT_GROUP','DELETE_GROUP']}><GroupAdministration titre="Groupes" /></AdminOrPermissionRoute>} />
      <Route path="/administration-champs" element={<AdminOrPermissionRoute anyPermission={['SEE_CHAMP','CREATE_CHAMP','EDIT_CHAMP','DELETE_CHAMP']}><ChampsAdministration titre="Champs personnalisés" /></AdminOrPermissionRoute>} />
      <Route path="/administration-champs/:id" element={<AdminOrPermissionRoute anyPermission={['SEE_CHAMP','EDIT_CHAMP']}><ChampDetail titre="Détails du champ" /></AdminOrPermissionRoute>} />

      <Route path="/APIKeys" element={<Navigate to="/administration?tab=apikeys" replace />} />

      {/* /analytics route removed; advanced statistics available at /statistiques for users with SEE_STATS permission */}


    </Routes>
  );
}

export default AppRoutes;
